<template>
  <el-dialog :show-close="false" id="inviteDialog" :visible.sync="dialogVisible" width="350px">
      <div class="imgbox" id="energyAnalysisPanel">
        <img class="inviteImg" src="@/assets/img/invite.png" />
        <img class="inviteCode" :src="QrCode"/>
        <el-button class="inviteBtn" id="downFileBtn" @click="downFileByImg">下载到本地</el-button>
      </div>
  </el-dialog>
</template>
<script>
import { inviteFriends,inviteTeamFriends } from "@/api/request";
import moment from "moment"
import Html2Canvas from 'html2canvas'
export default {
  data() {
    return {
      dialogVisible: false,
      imageUrl: "",
      QrCode: "",
      form: {}
    };
  },
  methods: {
    init(type) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (type == 1) {
          this.getQrCode()
        } else {
          this.getQrTeamCode()
        }
          
      });
    },
    getQrCode() {
      inviteFriends({width: 300,inviterType: 1}).then(res => {
        let byteData = res.qrCodeBytes
        // 创建图像的 URL
        this.QrCode = 'data:image/png;base64,' + byteData 
    });
    },
    getQrTeamCode() {
      inviteTeamFriends({width: 300}).then(res => {
        let byteData = res.qrCodeBytes
        // 创建图像的 URL
        this.QrCode = 'data:image/png;base64,' + byteData 
    });
    },
    // 下载为png图片
    async downFileByImg () {
      try {
        // 文件名称
        let nowTime = moment().format('yyyy-MM-DD')
        const filename = `邀请好友-海报${nowTime}`
        Html2Canvas(document.querySelector('#energyAnalysisPanel'), {
          useCORS: true,
          ignoreElements: element => { // 跳过指定元素
            // 跳过下载按钮
            if (element.id === 'downFileBtn') {
              return true
            }
          }
        }).then(canvas => {
          const img = document.createElement('a')
          img.href = canvas.toDataURL('image/png')
          img.download = filename
          img.click()
        })
      } catch (error) {
      }
    },
  }
};
</script>
<style>
#inviteDialog .el-dialog__header {
  padding: 0;
}
#inviteDialog .el-dialog__body {
  padding: 0;
}
#inviteDialog .el-dialog {
    margin-top: 5vh!important;
    background: rgba(0, 0, 0, 0);
}
</style>
<style scoped>
.imgBox {
    position: relative;
}
.inviteImg {
  width: 100%;
  z-index: 8888;
  /* height: 100%; */
}
.inviteBtn {
    position: absolute;
    bottom: 54px;
    left: 120px;
    color: #4d6fff;
}
.inviteCode {
    width: 136px;
    height: 136px;
    border-radius: 50%;
    position: absolute;
    top: 426px;
    left: 107px;
    z-index: 9999;
}
</style>